export enum TipoTitolare
{
    PERSONA_FISICA = "PF",
    PERSONA_GIURIDICA = "PG"
}